var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRt04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49967 5.00806H7.95661C8.20273 5.00806 8.44405 5.07618 8.65384 5.20488L9.11073 5.48517C9.23419 5.56091 9.27462 5.72134 9.2018 5.84654L8.64148 6.80997C8.56712 6.93782 8.61102 7.10177 8.73933 7.17535L9.51576 7.62066C9.64328 7.6938 9.80594 7.64994 9.87941 7.5226L10.4405 6.55012C10.5137 6.42318 10.6756 6.37913 10.8031 6.45146L11.7452 6.9862C11.8734 7.059 11.9182 7.22207 11.8452 7.35019L11.2787 8.34399C11.206 8.47136 11.2499 8.63345 11.3768 8.70688L12.1729 9.16749C12.3002 9.24113 12.4631 9.19784 12.537 9.07073L13.1135 8.07933C13.1851 7.95615 13.3409 7.91105 13.4673 7.97692L13.8767 8.19034C14.067 8.28955 14.2784 8.34135 14.493 8.34136L15.833 8.34139C17.6747 8.34139 19.1663 8.99972 19.1663 10.8414V12.2417C19.1663 12.3889 19.0471 12.5082 18.9 12.5084L1.09999 12.5292C0.952589 12.5294 0.833008 12.4099 0.833008 12.2625V6.67472C0.833008 6.2327 1.0086 5.80877 1.32116 5.49621C1.63372 5.18365 2.05765 5.00806 2.49967 5.00806Z",
    fill: "#5096FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 14.1747C0.833008 14.6168 1.0086 15.0407 1.32116 15.3533C1.63372 15.6658 2.05765 15.8414 2.49967 15.8414H17.4997C17.9417 15.8414 18.3656 15.6658 18.6782 15.3533C18.9908 15.0407 19.1663 14.6168 19.1663 14.1747V12.5081H0.833008V14.1747Z",
    fill: "#CFE5FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.3457,
    y: 5.36792,
    width: 1.66667,
    height: 2.00356,
    rx: 0.266667,
    transform: "rotate(30 9.3457 5.36792)",
    fill: "#DBECFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0391,
    y: 6.86694,
    width: 1.66667,
    height: 2.00001,
    rx: 0.266667,
    transform: "rotate(30 12.0391 6.86694)",
    fill: "#DBECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRt04);
export default __webpack_public_path__ + "static/media/icon_RT04.b723ab740ed46c6fa115147b6f3e0899.svg";
export { ForwardRef as ReactComponent };